import { render, staticRenderFns } from "./CurriculumQuery.vue?vue&type=template&id=8314247a&lang=pug"
import script from "./CurriculumQuery.vue?vue&type=script&lang=js"
export * from "./CurriculumQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports